<template>
    <div class="TooltipIcon">
        <span variant="outline-grey" v-b-tooltip.body.window.hover.bottom.html :title="tooltip" :disabled="disabled">
            <icon-svg size="14" :icon="icon" :bold="bold" :light="light"></icon-svg>
            
        </span>
    </div>
</template>

<script>
//import { mapState, mapMutations, mapActions, mapGetters, mapTypes } from 'vuex'
import IconSvg from '@/components/shared/IconSvg'
export default {
    name: 'TooltipIcon',
    components: {
        IconSvg
    },
    props: {
        icon: String,
        text: String,
        bold: Boolean,
        light: Boolean,
        tooltip: String,
        disabled: Boolean,
        save: Boolean
    },
    data() {
        return {

        }
    },
    mounted() {

    },
    computed: {
        iconVariant() {
            if (this.bold) {
                return 'bold';
            } else if (this.light) {
                return 'light';
            } else {
                return 'regular';
            }
        }
    }
}
</script>

<style  lang="scss">
//@import './../../scss/_theme.scss';

    .TooltipIcon {
        margin-left: 10px;
        margin-right: 10px;
        margin-top: 0px;
        margin-bottom: 00px;
        float:right;
    }
</style>



// WEBPACK FOOTER //
// src/components/shared/TooltipIcon.vue